import { FiltersIntel } from 'src/types.d'

const initialState: FiltersIntel = {}
export default (state = initialState, action) => {
  switch (action.type) {
    case 'filters/intel/set':
      return { ...state, ...action.payload }
    default:
      return state
  }
}
